export const oss = ['OSO', 'OSA'];
export const rss = ['SNCOIC'];

export const rsReportBillets = [
    ...rss,
    ...oss,
    'XO',
    'MAC',
    'MPA',
    'Ops Officer',
    'CO'
];

export const districtReportBillets = [
    ...rsReportBillets,
    'Emv Team',
    'AAOP',
    'AMACO',
    'Public Affairs',
    'MACO',
    'RAO',
    'MPAO',
    'Marketing Chief',
    'Communication Chief'
];

export const regionalReportBillets = [
    ...districtReportBillets,
    'ERR Marketing Specialist',
    'WRR Marketing Specialist'
];

export const mcrcReportBillets = [
    ...regionalReportBillets,
    'MCRC Communication',
    'MCRC Advertising',
    'Commanding General',
    'MCRC Ops',
    'MCRC Marketing'
];

export const rsReportOnlyBillets = ['XO', 'MAC', 'MPA', 'Ops Officer', 'CO'];

export const districtReportOnlyBillets = [
    'Emv Team',
    'AAOP',
    'AMACO',
    'Public Affairs',
    'MACO',
    'RAO',
    'MPAO',
    'Marketing Chief',
    'Communication Chief'
];

export const regionalReportOnlyBilletsEast = ['ERR Marketing Specialist'];

export const regionalReportOnlyBilletsWest = ['WRR Marketing Specialist'];

export const mcrcReportOnlyBillets = [
    'MCRC Communication',
    'MCRC Advertising',
    'Commanding General',
    'MCRC Ops',
    'MCRC Marketing'
];



// WEBPACK FOOTER //
// ./src/helpers/billetList.js